import { gql } from 'src/__generated__';
import { AlertsV2_GetDevicesQuery } from '@/__generated__/graphql';

export type DeviceAlertNotification = AlertsV2_GetDevicesQuery['devices'][number];

const ALERT_STATE_FRAGMENT = gql(`#graphql
  fragment AlertStateFragment on AlertConfigurationByState {
    comparisonType
    thresholdMin
    thresholdMax
    thresholdValue
    notificationDelaySec
    metricUnit
  }
`);

const GET_DEVICES = gql(`#graphql
query AlertsV2_GetDevices($input: DevicesInput, $pagination: PaginationInput) {
  devicesPageInfo(input: $input, pagination: $pagination) {
    totalCount
    pageNumber
    limit
    offset
    count
  }
  devices(input: $input, pagination: $pagination) {
    id
    profile {
      id
      name
    }
    alerts {
      id
      alertConfigurations {
        id
        deviceId
        metricName
        unit
        configurations {
          __typename
          ... on RangeStateConfiguration {
            state
          }
          ... on ThresholdStateConfiguration {
            state
          }
        }
      }
      summaryNotificationConfig {
        id
        notifyEmail
        notifySms
        notifyWhatsapp 
        notifyPush
      }
      notificationConfig {
        id
        notifyEmail
        notifySms
        notifyWhatsapp
        notifyPush
      }
    }
    users {
      user {
        id
        email
        fullName
        phone
      }
      alertNotificationConfig: alertNotificationConfiguration {
        id
        notifyEmail
        notifySms
        notifyWhatsapp 
        notifyPush
      }
    }
  }
}
`);

export default GET_DEVICES;
